import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarHeading,
  ToolbarDescription,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import { BackButton } from "@/components/button";
import { HarborRequestListings } from "./HarborRequestListings";

const HarborRequestManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <div className="flex items-center gap-3">
                <BackButton customBackPath="/habor-management" />
                <div>
                  <ToolbarPageTitle text="Harbor Requests" />
                  <ToolbarDescription>
                    Manage incoming harbor create/update requests here.
                  </ToolbarDescription>
                </div>
              </div>
            </ToolbarHeading>
          </Toolbar>

          <div className="mt-6">
            <HarborRequestListings />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export default HarborRequestManagement;
